import iconix from '@decisiv/iconix';

const oemOptions = [
  {
    id: 'all',
    label: 'ALL',
    value: 'all',
  },
  {
    id: 'dcv',
    label: 'DCV',
    value: 'dcv',
  },
  {
    id: 'flt',
    label: 'FLT',
    value: 'flt',
  },
  {
    id: 'greatdane',
    label: 'GREATDANE',
    value: 'greatdane',
  },
  {
    id: 'hino',
    label: 'HINO',
    value: 'hino',
  },
  {
    id: 'isuzu',
    label: 'ISUZU',
    value: 'isuzu',
  },
  {
    id: 'mck',
    label: 'MCK',
    value: 'mck',
  },
  {
    id: 'mich',
    label: 'MICH',
    value: 'mich',
  },
  {
    id: 'pcar',
    label: 'PCAR',
    value: 'pcar',
  },
  {
    id: 'stl',
    label: 'STL',
    value: 'stl',
  },
  {
    id: 'tico',
    label: 'TICO',
    value: 'tico',
  },
  {
    id: 'trimble',
    label: 'TRIMBLE',
    value: 'trimble',
  },
  {
    id: 'vlv',
    label: 'VLV',
    value: 'vlv',
  },
  {
    id: 'vce',
    label: 'VCE',
    value: 'vce',
  },
  {
    id: 'wlt',
    label: 'WLT',
    value: 'wlt',
  },
];

const dealerTypeOptions = [
  {
    id: 'all',
    label: 'ALL',
    value: 'all',
  },
  {
    id: 'FLEET',
    label: 'FLEET Fleet Owner',
    value: 'FLEET',
  },
  {
    id: 'FREE',
    label: 'FREE Service Location',
    value: 'FREE',
  },
  {
    id: 'MEMBER',
    label: 'MEMBER Noop Service Location',
    value: 'MEMBER',
  },
  {
    id: 'PAID',
    label: 'PAID Service Location',
    value: 'PAID',
  },
  {
    id: 'PARTNER',
    label: 'PARTNER Service Location',
    value: 'PARTNER',
  },
  {
    id: 'UPTIME_CENTER',
    label: 'UPTIME CENTER Service Location',
    value: 'UPTIME_CENTER',
  },
];

const sourceOptions = [
  {
    id: 'ALL',
    label: 'All',
    value: 'ALL',
  },
  {
    id: 'INTEGRATION_TEST',
    label: 'Integration Test',
    value: 'INTEGRATION_TEST',
  },
  {
    id: 'CACHE',
    label: 'Cache',
    value: 'CACHE',
  },
  {
    id: 'LIVE',
    label: 'Live',
    value: 'LIVE',
  },
  {
    id: 'AUTOMATIC_RETRY',
    label: 'Automatic Retry',
    value: 'AUTOMATIC_RETRY',
  },
  {
    id: 'MANUAL_RETRY',
    label: 'Manual Retry',
    value: 'MANUAL_RETRY',
  },
];

const triggerOptions = [
  {
    id: 'ALL',
    label: 'All',
    value: 'ALL',
  },
  {
    id: 'http_api_request',
    label: 'HTTP',
    value: 'http',
  },
  {
    id: 'application_event',
    label: 'Application Event',
    value: 'application_event',
  },
];

const statusOptions = [
  {
    id: 'ALL',
    label: 'All',
    value: 'ALL',
    decoration: {
      type: 'Badge',
      icon: iconix.Asterisk,
      color: 'information',
    },
  },
  {
    id: 'FAILED',
    label: 'Failed',
    value: 'failed',
    decoration: {
      type: 'Badge',
      icon: iconix.ExclamationTriangle,
      color: 'danger',
    },
  },
  {
    id: 'SUCCEEDED',
    label: 'Succeeded',
    value: 'succeeded',
    decoration: {
      type: 'Badge',
      icon: iconix.CheckCircleF,
      color: 'success',
    },
  },
  {
    id: 'NOT_FOUND',
    label: 'Succeeded - No Results',
    value: 'not_found',
    decoration: {
      type: 'Badge',
      icon: iconix.CheckCircle,
      color: 'success',
    },
  },
  {
    id: 'COMPLETED_WITH_ERRORS',
    label: 'Completed with Errors',
    value: 'COMPLETED_WITH_ERRORS',
    decoration: {
      type: 'Badge',
      icon: iconix.ExclamationTriangle,
      color: 'warning',
    },
  },
  {
    id: 'BLOCKED_BY_CIRCUIT_BREAKER',
    label: 'Blocked by Circuit Breaker',
    value: 'BLOCKED_BY_CIRCUIT_BREAKER',
    decoration: {
      type: 'Badge',
      icon: iconix.ExclamationShield,
      color: 'warning',
    },
  },
  {
    id: 'RE_ENQUEUED_BY_CIRCUIT_BREAKER',
    label: 'Re Enqueued by Circuit Breaker',
    value: 'RE_ENQUEUED_BY_CIRCUIT_BREAKER',
    decoration: {
      type: 'Badge',
      icon: iconix.ExclamationShield,
      color: 'warning',
    },
  },
  {
    id: 'BLOCKED_BY_CONDITION_RULE',
    label: 'Blocked by Condition',
    value: 'BLOCKED_BY_CONDITION_RULE',
    decoration: {
      type: 'Badge',
      icon: iconix.ExclamationShield,
      color: 'information',
    },
  },
];

const hourOptions = Array.from({ length: 24 }, (_, hour) => {
  const id = String(hour).padStart(2, '0');
  const period = hour < 12 ? 'AM' : 'PM';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return {
    id,
    label: `${hour12}:00 ${period}`,
    value: id,
  };
});

export {
  oemOptions,
  dealerTypeOptions,
  sourceOptions,
  triggerOptions,
  statusOptions,
  hourOptions,
};
